import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { GiftCard, GiftCardCreate, GiftCardFilter } from '../data/giftCard';

export function createGiftCardService(client: AxiosInstance) {
  return createCrudService<GiftCard, GiftCardCreate, GiftCardFilter>(
    client,
    '/sales/GiftCard',
    'id',
  );
}

export type GiftCardService = CrudService<GiftCard, GiftCardCreate, GiftCardFilter>;
